/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { v4 as uuidv4 } from 'uuid';
import {
  Checkbox,
  Modal,
  Popup,
  List,
  Loader,
  Segment,
  Dimmer,
  Image,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import $ from 'jquery';
import api from '../../api';
import SettingContentsHeader from './SettingContentsHeaderByPolicys';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import NewPolicyModal from '../Modal/NewPolicyModal';
import EditPolicyModal from '../Modal/EditPolicyModal';
import WithRouter from '../Extensions/WithRouter';
import CreateJiraIssueModal from '../Jira/CreateJiraIssueModal';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';

class PolicySetting extends Component {
  constructor(props) {
    super(props);
    this.modalHeader = null;
    this.modalBody = null;
    this.policySetting = React.createRef();
    this.state = {
      isOpenMCP: false,
      isOpenMDP: false,
      isOpenMEP: false,
      isOpenAlert: false,
      isOpenMCI: false,
      policyList: [],
      isSort: false,
      pageSize: 20,
      //currentPage: 1,
      sortColumn: '1',
      //error: false,
      //hasMorePolicyList: true,
      isLoading: false,
      itemsChecked: false,
      checkValue: [],
      activeIndex: '',
      selectedPolicyId: '',
      policyFilter: '',
      projectList: [],
      popupStatus: {
        projectPopup: false,
        conditionPopup: false,
      },
      isPageLoading: false,
    };
    this.clearSearch = this.clearSearch.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleMEPOpen = this.handleMEPOpen.bind(this);
    this.handleMEPClose = this.handleMEPClose.bind(this);
    this.handleMCPOpen = this.handleMCPOpen.bind(this);
    this.handleMCPClose = this.handleMCPClose.bind(this);
    this.handleMDPOpen = this.handleMDPOpen.bind(this);
    this.handleMDPClose = this.handleMDPClose.bind(this);
    this.handleMCIOpen = this.handleMCIOpen.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handleAlertClose = this.handleAlertClose.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleNewPolicyCallback = this.handleNewPolicyCallback.bind(this);
    this.handleJiraIssueCallback = this.handleJiraIssueCallback.bind(this);
    this.deletePolicy = this.deletePolicy.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();

    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.setting_table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 0) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });

    $(document).on('mouseover', '.setting_policy_content .setting_policy_table .policy_name', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;

    if (prevState.isOpenMCP !== this.state.isOpenMCP || prevState.isOpenMDP !== this.state.isOpenMDP || prevState.isOpenMEP !== this.state.isOpenMEP || prevState.isOpenAlert !== this.state.isOpenAlert) {
      this.handlePopupClose();
    }

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getsPolicyList();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  handleFilter(value) {
    this.setState(
      {
        policyFilter: value,
        policyList: [],
        sortColumn: '7',
        itemsChecked: false,
        checkValue: [],
      },
      () => {
        this.getsPolicyList();
      }
    );
  }

  handleCheckAll() {
    const { itemsChecked, policyList } = this.state;
    const newState = [];

    if (itemsChecked) {
      this.setState({
        itemsChecked: false,
        checkValue: [],
      });
    } else {
      const num = policyList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(policyList[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        itemsChecked: true,
        checkValue: unique,
      });
    }
  }

  handleCheckChange(e, { value }) {
    const { checkValue, policyList } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }
    if (newState.length !== 0 && newState.length !== policyList.length) {
      this.setState({
        checkValue: newState,
        itemsChecked: false,
      });
    } else {
      this.setState({
        checkValue: newState,
      });
    }
  }

  handleMCPOpen() {
    this.setState({
      isOpenMCP: true,
    });
  }

  handleMCPClose() {
    this.setState({
      isOpenMCP: false,
    });
  }

  handleMDPOpen() {
    const { t } = this.props;
    const { checkValue } = this.state;

    if (checkValue.length === 0) {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('settings.message.select_one_policy');
      this.setState({
        isOpenAlert: true,
      });
    } else {
      this.setState({
        isOpenMDP: true,
      });
    }
  }

  handleMCIOpen() {
    const { checkValue } = this.state;
    const { t } = this.props;

    if (checkValue.length === 0) {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('settings.message.select_one_policy');
      return this.setState({
        isOpenAlert: true,
      });
    }

    if (checkValue.length > 1) {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('settings.message.select_one_policy_jira');
      return this.setState({
        isOpenAlert: true,
      });
    }
    this.setState({
      isOpenMCI: true,
      selectedPolicyId: checkValue[0],
    });
  }

  handleMDPClose() {
    this.setState({
      isOpenMDP: false,
    });
  }

  handleAlertClose() {
    this.setState({
      isOpenAlert: false,
    });
  }

  handlePopupOpen(id) {
    const status = {
      projectPopup: false,
      conditionPopup: true,
    };
    this.setState({
      popupStatus: status,
      activeIndex: id,
    });
  }

  handlePopupClose() {
    const status = {
      projectPopup: false,
      conditionPopup: false,
    };
    this.setState({
      popupStatus: status,
      activeIndex: '',
    });
  }

  handleSearch(value) {
    this.setState(
      {
        searchKeyword: value,
        policyList: [],
        checkValue: [],
      },
      () => {
        this.getsPolicyList();
      }
    );
  }

  handleNewPolicyCallback() {
    this.setState(
      {
        policyList: [],
        checkValue: [],
      },
      () => {
        this.getsPolicyList();
      }
    );
  }

  handleJiraIssueCallback() {
    this.setState(
      {
        policyList: [],
        checkValue: [],
        isOpenMCI: false,
      },
      () => {
        this.getsPolicyList();
      }
    );
  }

  handleMEPOpen(policyId) {
    this.setState({
      isOpenMEP: true,
      selectedPolicyId: policyId,
    });
  }

  handleMEPClose(value) {
    if (value) {
      this.setState(
        {
          searchKeyword: '',
          policyList: [],
          isOpenMEP: false,
        },
        () => {
          this.getsPolicyList();
        }
      );
    } else {
      this.setState({
        isOpenMEP: false,
      });
    }
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortColumn) {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: false,
          policyList: [],
          activeIndex: '',
        },
        () => {
          this.getsPolicyList();
        }
      );
    } else {
      this.setState(
        {
          sortColumn: e.currentTarget.dataset.id,
          isSort: !isSort,
          policyList: [],
          activeIndex: '',
        },
        () => {
          this.getsPolicyList();
        }
      );
    }
  };

  getsPolicyList = (pageNo, limit) => {
    let text;
    const { isSort, sortColumn, policyList } = this.state;
    const page = pageNo || 1;
    const perPage = limit || this.state.pageSize;

    switch (true) {
    case sortColumn === '1':
      if (isSort) {
        text = 'policy';
      } else {
        text = 'policy_r';
      }
      break;
    case sortColumn === '2':
      if (isSort) {
        text = 'coverage';
      } else {
        text = 'coverage_r';
      }
      break;
    case sortColumn === '3':
      if (isSort) {
        text = 'category';
      } else {
        text = 'category_r';
      }
      break;
    case sortColumn === '4':
      if (isSort) {
        text = 'condition_r';
      } else {
        text = 'condition';
      }
      break;
    case sortColumn === '5':
      if (isSort) {
        text = 'project_r';
      } else {
        text = 'project';
      }
      break;
    case sortColumn === '6':
      if (isSort) {
        text = 'creator';
      } else {
        text = 'creator_r';
      }
      break;
    case sortColumn === '7':
      if (isSort) {
        text = 'modified_r';
      } else {
        text = 'modified';
      }
      break;
    case sortColumn === '8':
      if (isSort) {
        text = 'revision_r';
      } else {
        text = 'revision';
      }
      break;
    default:
      text = 'modified';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getsPolicyList(
            {
              search: this.state.searchKeyword,
              filter: this.state.policyFilter,
              page,
              limit: perPage,
              order: text,
            }
          )
          .then((response) => {
            if (this.state.policyList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextPolicyList = response.response.map((item) => {
              return {
                id: item.id,
                name: item.name,
                hasJira: item.has_jira,
                coverage: item.coverage,
                category: item.category,
                condition: item.condition,
                conditionDetail: item.condition_detail,
                revision: item.revision,
                projectCount: item.project_count,
                creator: item.creator,
                lastModified: item.last_modified,
              };
            });
            this.setState({
              //totalCount: response.count,
              //currentPage: response.pagination.current,
              //prevPage: response.pagination.previous,
              //nextPage: response.pagination.next,
              pageSize: response.pagination.per_page,
              //totalPage: response.pagination.pages,
              //currentCount: response.pagination.count,
              //hasMorePolicyList: response.pagination.next !== null,
              isLoading: false,
              policyList: [...policyList, ...nextPolicyList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              isLoading: false,
            });
          });
      }
    );
  };

  getSPolicyProjectDetail = (policyId) => {
    const status = {
      projectPopup: true,
      conditionPopup: false,
    };
    api
      .getSPolicyProjectDetail(policyId)
      .then((response) => {
        const data = response.response;
        this.setState({
          popupStatus: status,
          activeIndex: policyId,
          projectList: data.project_list,
          //condition_detail: [],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
        });
      });
  };

  deletePolicy() {
    const idArr = this.state.checkValue;
    api
      .deletesPolicy(
        { policy_ids: idArr, }
      )
      .then(() => {
        this.setState(
          {
            policyList: [],
            checkValue: [],
            itemsChecked: false,
            searchKeyword: '',
            isOpenMDP: false,
          },
          () => {
            this.getsPolicyList();
          }
        );
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isLoading: false,
          isOpenMDP: false,
        });
      });
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        policyList: [],
        checkValue: [],
      },
      () => {
        this.getsPolicyList();
      }
    );
  }

  closeModal() {
    this.setState({
      isOpenMCI: false,
    });
  }

  renderConditionValue(data) {
    const objKey = data.conditionDetail;
    const { activeIndex, popupStatus } = this.state;
    const { t } = this.props;
    if (data.category === 'component') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && activeIndex === data.id
            }
            onOpen={() => {
              return this.handlePopupOpen(data.id);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.component.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('contents_header.link_header.components')}
                      (
                      {objKey.component.length}
                      )
                    </List.Header>
                    <List.List>
                      {
                        objKey.component.map((item) => {
                          return (
                            <List.Item key={uuidv4()}>
                              {
                                item.component ? (
                                  <List.Content>
                                    <List.Header>{item.component}</List.Header>
                                    <List.List className="block">
                                      {
                                        item.version_condition ? (
                                          <List.Item>
                                            <List.Content>
                                              <List.Header className="inline">{t('settings.list.condition_policy')}</List.Header>
                                              <List.Description className="inline">{item.version_condition}</List.Description>
                                            </List.Content>
                                          </List.Item>
                                        ) : null
                                      }
                                      {
                                        item.selected_version ? (
                                          <List.Item>
                                            <List.Content>
                                              <List.Header className="inline">{t('settings.list.version_policy')}</List.Header>
                                              <List.Description className="inline">{item.selected_version}</List.Description>
                                            </List.Content>
                                          </List.Item>
                                        ) : null
                                      }
                                    </List.List>
                                  </List.Content>
                                ) : null
                              }
                            </List.Item>
                          );
                        })
                      }
                    </List.List>
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'security') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && activeIndex === data.id
            }
            onOpen={() => {
              return this.handlePopupOpen(data.id);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.severity.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('settings.list.security_risk_severity')}
                      (
                      {objKey.severity.length}
                      )
                    </List.Header>
                    <List.List>
                      {
                        objKey.severity.map((item) => {
                          return (
                            <List.Item key={uuidv4()}>
                              <List.Content>
                                {
                                  item === 'critical' && 'Critical'
                                }
                                {
                                  item === 'high' && 'High'
                                }
                                {
                                  item === 'medium' && 'Medium'
                                }
                                {
                                  item === 'low' && 'Low'
                                }
                              </List.Content>
                            </List.Item>
                          );
                        })
                      }
                    </List.List>
                  </List.Item>
                ) : null
              }
              {
                objKey.code.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('settings.list.securities')}
                      (
                      {objKey.code.length}
                      )
                    </List.Header>
                    <List.List>
                      {
                        objKey.code.map((item) => {
                          return (
                            <List.Item key={uuidv4()}>
                              <List.Content>{item}</List.Content>
                            </List.Item>
                          );
                        })
                      }
                    </List.List>
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'license') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && activeIndex === data.id
            }
            onOpen={() => {
              return this.handlePopupOpen(data.id);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.family.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('list.title.license_family')}
                      (
                      {objKey.family.length}
                      )
                    </List.Header>
                    <List.List>
                      {
                        objKey.family.map((item) => {
                          return (
                            <List.Item key={uuidv4()}>
                              <List.Content>
                                {
                                  item === 'protective' && 'Protective'
                                }
                                {
                                  item === 'permissive' && 'Permissive'
                                }
                                {
                                  item === 'others' && 'Others'
                                }
                              </List.Content>
                            </List.Item>
                          );
                        })
                      }
                    </List.List>
                  </List.Item>
                ) : null
              }
              {
                objKey.name.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('contents_header.link_header.licenses')}
                      (
                      {objKey.name.length}
                      )
                    </List.Header>
                    <List.List>
                      {
                        objKey.name.map((item) => {
                          return (
                            <List.Item key={uuidv4()}>
                              <List.Content>
                                {item}
                              </List.Content>
                            </List.Item>
                          );
                        })
                      }
                    </List.List>
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    } else if (data.category === 'litigator') {
      if (objKey.length !== 0) {
        return (
          <Popup
            trigger={(
              <span className="number" style={{ cursor: 'pointer' }}>
                {data.condition}
              </span>
            )}
            on="click"
            hideOnScroll
            position="bottom left"
            style={{ marginLeft: '-16.5px' }}
            open={
              popupStatus.conditionPopup && activeIndex === data.id
            }
            onOpen={() => {
              return this.handlePopupOpen(data.id);
            }}
            onClose={this.handlePopupClose}
          >
            <List>
              {
                objKey.name.length !== 0 ? (
                  <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                    <List.Header style={{ margin: '0 0 5px 0' }}>
                      {t('contents_header.link_header.litigators')}
                      (
                      {objKey.name.length}
                      )
                    </List.Header>
                    <List.List>
                      {
                        objKey.name.map((item) => {
                          return (
                            <List.Item key={uuidv4()}>
                              <List.Content>
                                {
                                  item === 'mchardy' && 'McHardy'
                                }
                                {
                                  item === 'sfc' && 'SFC'
                                }
                                {
                                  item === 'patents' && 'Patent Module'
                                }
                              </List.Content>
                            </List.Item>
                          );
                        })
                      }
                    </List.List>
                  </List.Item>
                ) : null
              }
            </List>
          </Popup>
        );
      }
    }
    return (
      <span className="number">
        {data.condition}
      </span>
    );
  }

  render() {
    const {
      policyList,
      itemsChecked,
      isSort,
      sortColumn,
      checkValue,
      activeIndex,
      isLoading,
      isOpenMEP,
      isOpenMCI,
      isOpenAlert,
      selectedPolicyId
    } = this.state;
    const { location, state, t } = this.props;
    const pathname = location.pathname ? location.pathname : location;

    return (
      <div className="setting_policy" ref={this.policySetting}>
        <SettingContentsHeader
          changePolicyFilter={this.handleFilter}
          clearSearch={this.clearSearch}
          onChangeSearch={this.handleSearch}
          addNewPolicy={this.handleMCPOpen}
          deletePolicy={this.handleMDPOpen}
          addNewIssue={this.handleMCIOpen}
          policyListLength={policyList.length}
          location={pathname}
          state={state}
          translate={t}
        />
        <div className="content">
          <div className="setting_policy_content">
            <div className="setting_table_header">
              <div className="setting_table_header_inner">
                <table className="setting_policy_table table_header">
                  <colgroup>
                    <col style={{ width: '36px' }} />
                    <col style={{ width: '160px' }} />
                    <col style={{ width: '11%' }} />
                    <col style={{ width: '11%' }} />
                    <col style={{ width: '9%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        {this.props.state.user.isAdmin && policyList.length !== 0 && (
                          <Checkbox checked={itemsChecked} onChange={this.handleCheckAll} />
                        )}
                      </th>
                      <th className="policy_name">
                        <a className="sorting_button" data-id="1" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('settings.list.policy_name')}
                          {isSort && sortColumn === '1' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '1' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="8" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('settings.list.revision')}
                          {isSort && sortColumn === '8' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '8' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="2" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('settings.list.coverage')}
                          {isSort && sortColumn === '2' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '2' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="3" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('settings.list.category')}
                          {isSort && sortColumn === '3' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '3' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="4" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('settings.list.condition')}
                          {isSort && sortColumn === '4' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '4' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="5" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('settings.list.applied_projects')}
                          {isSort && sortColumn === '5' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '5' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="6" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('settings.list.created_by')}
                          {isSort && sortColumn === '6' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '6' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>
                        <a className="sorting_button" data-id="7" onClick={this.onChangeSorting} onKeyUp={this.onChangeSorting}>
                          {t('system.list.last_modified')}
                          {isSort && sortColumn === '7' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortColumn === '7' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            {
              !isLoading ? (
                <div>
                  {policyList.length !== 0 ? policyList.map((list) => {
                    return (
                      <div key={uuidv4()} className="setting_policy_table_wrap">
                        <table className="setting_policy_table">
                          <colgroup>
                            <col style={{ width: '36px' }} />
                            <col style={{ width: '160px' }} />
                            <col style={{ width: '11%' }} />
                            <col style={{ width: '11%' }} />
                            <col style={{ width: '9%' }} />
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '12%' }} />
                            <col style={{ width: '' }} />
                          </colgroup>
                          <tbody>
                            <tr>
                              <td>
                                <div className="content_wrapper">
                                  {
                                    this.props.state.user.isAdmin
                                  && (
                                    <Checkbox
                                      value={list.id}
                                      checked={checkValue.indexOf(list.id) > -1}
                                      onChange={this.handleCheckChange}
                                    />
                                  )
                                  }
                                </div>
                              </td>
                              <td className="policy_name">
                                {list.hasJira ? <Image className="jira_list" src={JiraLogo} style={{ width: '15px' }} avatar /> : null}
                                {list.name}
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.revision}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.coverage === 'company' && 'Company'}
                                  {list.coverage === 'project' && 'Project'}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.category === 'component' && 'Component'}
                                  {list.category === 'security' && 'Security'}
                                  {list.category === 'license' && 'License'}
                                  {list.category === 'litigator' && 'Litigator'}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper license">
                                  {this.renderConditionValue(list)}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {
                                    list.projectCount === 0 ? (
                                      <span>{list.projectCount}</span>
                                    ) : (
                                      <Popup
                                        trigger={(
                                          <span style={{ cursor: 'pointer' }}>
                                            {list.projectCount}
                                          </span>
                                        )}
                                        on="click"
                                        hideOnScroll
                                        position="bottom left"
                                        style={{ marginLeft: '-16px' }}
                                        open={
                                          this.state.popupStatus.projectPopup && activeIndex === list.id
                                        }
                                        onOpen={() => {
                                          return this.getSPolicyProjectDetail(list.id);
                                        }}
                                        onClose={this.handlePopupClose}
                                      >
                                        <List>
                                          <List.Item style={{ fontWeight: 'normal', fontSize: '12px' }}>
                                            <List.List>
                                              {
                                                this.state.projectList.map((item) => {
                                                  return (
                                                    <List.Item key={uuidv4()}>
                                                      <List.Icon name="folder" />
                                                      <List.Content>{item}</List.Content>
                                                    </List.Item>
                                                  );
                                                })
                                              }
                                            </List.List>
                                          </List.Item>
                                        </List>
                                      </Popup>
                                    )
                                  }
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.creator}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  {list.lastModified}
                                </div>
                              </td>
                              <td>
                                <div className="content_wrapper">
                                  <a
                                    className="edit_button"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      this.handleMEPOpen(list.id);
                                    }}
                                    onKeyUp={() => {
                                      this.handleMEPOpen(list.id);
                                    }}
                                  >
                                    {t('system.button.edit')}
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  }) : null}
                </div>
              ) : (
                <div>
                  <Segment>
                    <Dimmer active inverted>
                      <Loader size="large">{t('list.title.loading')}</Loader>
                    </Dimmer>
                  </Segment>
                </div>
              )
            }
          </div>
        </div>
        <NewPolicyModal
          isOpenMCP={this.state.isOpenMCP}
          closeModal={this.handleMCPClose}
          completeCallback={this.handleNewPolicyCallback}
          translate={t}
        />
        <EditPolicyModal
          isOpenMEP={isOpenMEP}
          closeModal={this.handleMEPClose}
          policyId={selectedPolicyId}
          completeCallback={this.handleNewPolicyCallback}
          translate={t}
        />
        <CreateJiraIssueModal
          isOpenMCI={isOpenMCI}
          selectedPolicyId={selectedPolicyId}
          closeModal={this.closeModal}
          completeCallback={this.handleJiraIssueCallback}
          translate={t}
        />
        <Modal open={this.state.isOpenMDP} onClose={this.handleMDPClose}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{t('settings.message.delete_policy')}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.handleMDPClose} onKeyUp={this.handleMDPClose}>
                    {t('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.deletePolicy} onKeyUp={this.deletePolicy}>
                    {t('modal.button.delete')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={isOpenAlert} onClose={this.handleAlertClose}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalHeader}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.handleAlertClose}
                    onKeyUp={this.handleAlertClose}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(PolicySetting))));
